import { render, staticRenderFns } from "./ErpIcmBackupMedia.vue?vue&type=template&id=29570774&scoped=true&"
import script from "./ErpIcmBackupMedia.vue?vue&type=script&lang=js&"
export * from "./ErpIcmBackupMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29570774",
  null
  
)

export default component.exports